export const ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE = 'adminNotifications';
